import { Box, Grid } from "@mui/material"
import Icon from "@mdi/react"
import { mdiFacebook, mdiInstagram } from "@mdi/js"

const SocialMedia = () => {
	return (
		<Grid container spacing={3}>
			<Grid item xs={6}>
				<a
					href="https://www.facebook.com/SafeHero-113013536815944/"
					target="_blank"
					rel="noopener noreferrer"
				>
					<div style={{ display: "flex", justifyContent: "center" }}>
						<Icon path={mdiFacebook} title="Facebook" size={1} color="#274041" />

						<Box ml={1}>Facebook</Box>
					</div>
				</a>
			</Grid>
			<Grid item xs={6}>
				<a
					href="https://www.instagram.com/safe.hero/?hl=de"
					target="_blank"
					rel="noopener noreferrer"
				>
					<div style={{ display: "flex", justifyContent: "center" }}>
						<Icon path={mdiInstagram} title="Instagram" size={1} color="#274041" />

						<Box ml={1}>Instagram</Box>
					</div>
				</a>
			</Grid>
		</Grid>
	)
}

export default SocialMedia
